module.exports = __webpack_public_path__ + "img/change.6cba1bc8.svg";